import type { Routes } from '@angular/router';

export const INSPIRATIONS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#modules/inspirations/layouts/inspirations-layout/inspirations-layout.component').then(
                (m) => m.InspirationsLayoutComponent
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'new-inspirations',
            },
            {
                path: 'new-inspirations',
                loadComponent: () =>
                    import('#modules/inspirations/views/inspirations/inspirations.component').then((m) => m.InspirationsComponent),
            },
        ],
    },
];
